module.exports = "<div class=\"banner\" ng-hide=\"$root.isMember\">\n  <div class=\"welcome\">\n    <h3>Welcome to {{main.siteConst.name}}!</h3>\n    <ul>\n      <li ng-repeat=\"point in main.siteConst.advert.tour|limitTo: 5\">\n        <i class=\"glyphicon glyphicon-check\"></i>\n        <span>{{point}}</span> \n      </li>\n    </ul>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/site_core/src/components/slider/slider.html
// module id = 179
// module chunks = 0